import { useQuery } from "@tanstack/react-query";
import { AI_CONFIGURATION_QUERY_KEY } from "../constants";
import { AIService } from "../services/ai.service";

export const useGetGenAIConfiguration = (briefId: string) => {
  const {
    data: genAIConfigurationData,
    isFetching: isFetchingGenAIConfiguration,
    error: errorGenAIConfiguration,
    isSuccess: isSuccessGenAIConfiguration,
  } = useQuery({
    queryKey: [...AI_CONFIGURATION_QUERY_KEY],
    queryFn: () => AIService.getGenAIConfiguration(briefId),
    enabled: !!briefId
  });
  return {
    genAIConfigurationData,
    isFetchingGenAIConfiguration,
    errorGenAIConfiguration,
    isSuccessGenAIConfiguration,
  };
};
